import { useTheme } from '@pinwheel/origami';
import { isInternetExplorer } from './browser-detection';
export function useScrolledViewSx(_a) {
    var isScrolled = _a.isScrolled;
    var resolveColor = useTheme().resolveColor;
    var background = resolveColor({
        type: 'theme',
        colorLegacy: 'Neutral/0',
        colorNext: 'background/default',
    });
    return isInternetExplorer()
        ? {}
        : {
            // This before element should be present even when
            // .isScrolled class is not yet assigned, otherwise
            // iOS demonstrates a strange frozen scrolling behavior
            // after the first frame of scrolling occurs.
            '&::before': {
                boxShadow: isScrolled ? "0 0 15px 15px ".concat(background) : 'none',
                display: 'block',
                content: '" "',
                position: 'fixed',
                width: '100%',
                height: 0,
                left: 0,
                right: 0,
            },
            '&::after': {
                display: 'block',
                content: '" "',
                position: 'absolute',
                left: 0,
                right: 0,
                bottom: 0,
                height: 0,
                backgroundColor: {
                    type: 'theme',
                    colorLegacy: 'Neutral/0',
                    colorNext: 'background/default',
                },
                boxShadow: "0 -5px 15px 15px ".concat(background),
            },
        };
}
